import {
  Component, Input
} from '@angular/core';
import {
  ImagesCarouselBaseComponent
} from '../../../common-theme/base-components/shared/images-carousel-base/images-carousel-base.component';

@Component({
  selector: 'app-homepage-carousel',
  templateUrl: './homepage-carousel.component.html',
  styleUrls: [
    '../../../common-theme/base-components/shared/images-carousel-base/images-carousel-base.component.scss',
    './homepage-carousel.component.scss'
  ]
})

export class HomepageCarouselComponent extends ImagesCarouselBaseComponent {
  @Input() id: any;
  animateTitle: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/homepage-carousel/homepage-carousel.component.ts